import axios from 'axios'
import config from '@/lib/config.js'

const service = {
    login(username, password) {
        let params = {
            username: username,
            password: password
        }
        return axios.post(config.apiUrl + 'Users/Login', params)
    },
    logout(usertoken) {
        let params = {
            usertoken: usertoken
        }
        return axios.post(config.apiUrl + 'Users/Logout', params)
    },
    getUserInfo(usertoken) {
        return axios.get(config.apiUrl + 'Users/UserInfo', {
            params: {
                usertoken: usertoken
            }
        })
    },
    getLayerInventory(usertoken, cid) {
        return axios.get(config.apiUrl + 'ForecastValues/LayerInventory', {
            params: {
                usertoken: usertoken,
                cid: cid
            }
        })
    },
    defaultReportData(usertoken, cid, fid) {    
        return axios.get(config.apiUrl + 'Report/DefaultReportData', {
            params: {
                usertoken: usertoken,
                cid: cid,
                fid: fid
            }
        })
    },
    getForecastInventory(usertoken) {
        return axios.get(config.apiUrl + 'ForecastValues/ForecastInventory', {
            params: {
                usertoken: usertoken
            }
        })
    },
    getForecastVarInventory(usertoken, cid, fid) {
        return axios.get(config.apiUrl + 'ForecastValues/ForecastVarInventory', {
            params: {
                usertoken: usertoken,
                cid: cid,
                fid: fid
            }
        })
    },
    getPoints(usertoken) {
        return axios.get(config.apiUrl + 'UserPoints/GetPoints', {
            params: {
                usertoken: usertoken
            }
        })
    },
    deletePoint(usertoken, pointID) {
        return axios.delete(config.apiUrl + 'UserPoints/DeletePoint', {
            params: {
                usertoken: usertoken,
                pointID: pointID
            }
        })
    },
    readVarValues(usertoken, cid, fid, varid, lat, lon) {
        return axios.get(config.apiUrl + 'ForecastValues/ReadVarValues', {
            params: {
                usertoken: usertoken,
                cid: cid,
                fid: fid, 
                varid: varid, 
                lat: lat,
                lon: lon
            }
        })
    },
    addPoint(usertoken, cid, lat, lon, name) {       
        let params = {
            usertoken: usertoken,
            cid: cid,
            lat: lat,
            lon: lon,
            name: name
        };
        return axios.post(config.apiUrl + 'UserPoints/AddPoint', params)
    },
    editPoint(usertoken, id, lat, lon, name) {       
        let params = {
            usertoken: usertoken,
            id: id,
            lat: lat,
            lon: lon,
            name: name
        };
        return axios.put(config.apiUrl + 'UserPoints/EditPoint', params)
    },
    updateConfigProperty(usertoken, key, value) {
        let params = {
            usertoken: usertoken,
            key: key,
            value: value
        }
        return axios.post(config.apiUrl + 'UserConfig/UpdateConfigProperty', params)
    },
    getConfig(usertoken) {
        return axios.get(config.apiUrl + 'UserConfig/GetConfig', {
            params: {
                usertoken: usertoken,                
            }
        })
    }
}

export default service